import { render, staticRenderFns } from "./ProgramSupportList.vue?vue&type=template&id=a0c3ab8c"
import script from "./ProgramSupportList.vue?vue&type=script&lang=ts"
export * from "./ProgramSupportList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports